import { createFileRoute } from "@tanstack/react-router";
import { loadContentMeta, buildContentHead } from "@/lib/seo/contentHead";
import ContentPost from "@/pages/ContentPost";
const ContentPostRoute = () => <ContentPost contentType="podcasts" />;

export const Route = createFileRoute("/es/podcasts/$slug")({
  loader: ({ params }) => loadContentMeta("podcasts", params.slug, "es"),
  head: ({ params, loaderData }) =>
    buildContentHead(`/es/podcasts/${params.slug}`, loaderData),
  component: ContentPostRoute,
});

